'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISTINCE_ID = undefined;
exports.getDistinctID = getDistinctID;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FINGERPRINT_ID = 'fingerprintjs2Script';
var DISTINCE_ID = exports.DISTINCE_ID = 'DISTINCE_ID';

function loadFingerprint() {
  return new Promise(function (resolve, reject) {
    if (!!document.querySelector('#' + FINGERPRINT_ID)) resolve();

    var script = document.createElement('script');
    script.id = FINGERPRINT_ID;
    script.src = '//wx-static.keruyun.com/cdn/fingerprintjs2/1.5.1/fingerprint2.min.js';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    script.addEventListener('load', function () {
      script = null;
      resolve();
    });

    script.addEventListener('error', function () {
      reject(new Error('加载fingerprintjs2失败'));
    });
  });
}

function getDistinctID() {
  return new Promise(function (resolve) {
    var distinctID = _jsCookie2.default.get(DISTINCE_ID);
    if (distinctID) {
      resolve(distinctID);
    }

    loadFingerprint().then(function () {
      var fp = new Fingerprint2();
      fp.get(function (id) {
        _jsCookie2.default.set(DISTINCE_ID, id);
        resolve(id);
      });
    });
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kryfe/divolte/es/getDistinctID.js
// module id = 244
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63 64 65 66 67 68 69 70 71